import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const testimonials = [
    {
        name: "Ananya S.",
        role: "Dermatology patient",
        rating: 5,
        text: "Dr. Khatri took the time to understand my acne history before suggesting a plan. Six months in, my skin has genuinely transformed.",
    },
    {
        name: "Rohit P.",
        role: "Root canal patient",
        rating: 5,
        text: "I was dreading my RCT. Dr. Sachdev made the procedure painless and explained every step. Will recommend Mirrari to everyone.",
    },
    {
        name: "Meera J.",
        role: "Cosmetic dentistry",
        rating: 5,
        text: "The smile makeover is beyond what I imagined. The clinic feels warm, premium and very hygienic.",
    },
];

export default function Testimonials() {
    return (
        <section
            id="testimonials"
            className="py-24 md:py-32"
            data-testid="testimonials-section"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.6 }}
                    className="max-w-3xl"
                >
                    <span className="text-xs uppercase tracking-[0.3em] text-[#8A9A5B] font-medium">
                        — Kind Words
                    </span>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light text-[#1A221F] mt-4 leading-[1.1] tracking-tight">
                        Patient stories from <em className="italic text-[#3B5249]">Amravati.</em>
                    </h2>
                </motion.div>

                <div className="grid md:grid-cols-3 gap-6 mt-16">
                    {testimonials.map((t, i) => (
                        <motion.blockquote
                            key={t.name}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.1 }}
                            className="relative bg-white rounded-[2rem] p-8 border border-[#E8E6E1] shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(0,0,0,0.08)] transition-all duration-300"
                            data-testid={`testimonial-${i}`}
                        >
                            <Quote className="w-8 h-8 text-[#8A9A5B]/30 mb-5" />
                            <p className="text-[#1A221F] leading-relaxed text-base">
                                {t.text}
                            </p>
                            <footer className="mt-8 pt-6 border-t border-[#E8E6E1] flex items-center justify-between">
                                <div>
                                    <div className="font-display text-[#1A221F] font-medium">
                                        {t.name}
                                    </div>
                                    <div className="text-xs text-[#7A8C84] uppercase tracking-wider mt-0.5">
                                        {t.role}
                                    </div>
                                </div>
                                <div className="flex gap-0.5">
                                    {Array.from({ length: t.rating }).map((_, j) => (
                                        <Star
                                            key={j}
                                            className="w-4 h-4 fill-[#8A9A5B] text-[#8A9A5B]"
                                        />
                                    ))}
                                </div>
                            </footer>
                        </motion.blockquote>
                    ))}
                </div>
            </div>
        </section>
    );
}
